export default {
  SEARCH_CATALOG_ALLIANZ_MUNICIPALITY_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_MUNICIPALITY_QUERY'),
  CATALOG_ALLIANZ_MUNICIPALITY_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_MUNICIPALITY_REPOSITORY'),
  CATALOG_ALLIANZ_MUNICIPALITY_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_MUNICIPALITY_STATE_MANAGER'),
};
